import { render, staticRenderFns } from "./FaqSetting.vue?vue&type=template&id=20c0084d&scoped=true&"
import script from "./FaqSetting.vue?vue&type=script&lang=js&"
export * from "./FaqSetting.vue?vue&type=script&lang=js&"
import style0 from "./FaqSetting.vue?vue&type=style&index=0&id=20c0084d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c0084d",
  null
  
)

export default component.exports